<template>
  <div>
    <div :class="['select-by', !isLogged ? 'align-items-center' : '']">
      <div :class="['know-licenseplate', isLogged ? '' : 'mr-2']">
        <p>Non conosci la targa?</p>
      </div>
      <div :class="['select-dropdown', !isLogged ? 'justify-content-center' : '']">
        <div :class="['select-brand',{ active: isDropdownOpen }, !isLogged ? 'm-0' : '']">
          <p id="selectBrandBtn" v-on:click="toggleDropdown">Seleziona marca e modello</p>
        </div>
        <div class="vertical-ruler" v-if="isLogged && isNominale || isLogged && isLiveMarket || isLogged && isSponsor"></div>
        <div class="select-my-car" v-if="isLogged && isNominale || isLogged && isLiveMarket || isLogged && isSponsor" v-on:click="toggleMyCarDropdown">
          <p>
            Seleziona da le mie auto
            <span>
              <img
                :class="{ 'caret-down': true, rotated: isMyCarDropdownOpen }"
                src="../../../images/project-img/Arrow-Small-down.png"
                alt="caret down"
            /></span>
          </p>
        </div>
      </div>
    </div>
    <div id="dropdownContainer" :class="[isLogged ? 'dropdown-container' : 'dropdown-container-center',{ hidden: !isDropdownOpen }]">
      <div class="close-dropdown">
        <button type="button" id="closeDropdown" class="close-dropdown" v-on:click="closeDropdown">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.004"
            height="14"
            viewBox="0 0 14.004 14"
          >
            <path
              id="Icon_ionic-ios-close"
              data-name="Icon ionic-ios-close"
              d="M19.946,18.289l5-5A1.172,1.172,0,0,0,23.29,11.63l-5,5-5-5a1.172,1.172,0,1,0-1.657,1.657l5,5-5,5a1.172,1.172,0,1,0,1.657,1.657l5-5,5,5a1.172,1.172,0,1,0,1.657-1.657Z"
              transform="translate(-11.285 -11.289)"
              fill="#606060"
            />
          </svg>
        </button>
      </div>
      <form action="/allestimenti" method="POST" @submit="handleSubmit" ref="findCar">
        <input type="hidden" name="_token" :value="csrfToken" />
        <input type="text" hidden :value="quotation_type" name="quotation_type" />
        <input type="number" hidden :value="vehicle_type" name="vehicle_type" />
        <div class="find-car-container">
          <div class="form-group">
            <custom-select
              v-model="params.marca"
              :options="formattedOptions(options.marca)"
              :placeholder="placeholders.marca"
              :disabled="!options.marca || !Object.keys(options.marca).length"
              @change="handleSelectChange('marca')"
              :name="'choice[marca]'"
              :isOpen="openDropdown === 0"
              @toggle="handleToggle(0)"
            ></custom-select>

            <custom-select
              v-model="params.anno_im"
              :options="formattedOptions(options.anno_im)"
              :placeholder="placeholders.anno_im"
              :disabled="!options.anno_im || !Object.keys(options.anno_im).length"
              @change="handleSelectChange('anno_im')"
              :name="'choice[anno_im]'"
              :isOpen="openDropdown === 2"
              @toggle="handleToggle(2)"
            ></custom-select>

            <custom-select
              v-model="params.mese_im"
              :options="formattedOptions(options.mese_im)"
              :placeholder="placeholders.mese_im"
              :disabled="!options.mese_im || !Object.keys(options.mese_im).length"
              @change="handleSelectChange('mese_im')"
              :name="'choice[mese_im]'"
              :isOpen="openDropdown === 4"
              @toggle="handleToggle(4)"
            ></custom-select>

            <custom-select
              v-model="params.modello"
              :options="formattedOptions(options.modello)"
              :placeholder="placeholders.modello"
              :disabled="!options.modello || !Object.keys(options.modello).length"
              @change="handleSelectChange('modello')"
              :name="'choice[modello]'"
              :isOpen="openDropdown === 6"
              @toggle="handleToggle(6)"
            ></custom-select>

        </div>
        <div class="form-group">
              <custom-select
                v-model="params.alimentazione"
                :options="formattedOptions(options.alimentazione)"
                :placeholder="placeholders.alimentazione"
                :disabled="!options.alimentazione || !Object.keys(options.alimentazione).length"
                @change="handleSelectChange('alimentazione')"
                :name="'choice[alimentazione]'"
                :isOpen="openDropdown === 1"
                @toggle="handleToggle(1)"
              ></custom-select>

            <custom-select
              v-model="params.carrozzeria"
              :options="formattedOptions(options.carrozzeria)"
              :placeholder="placeholders.carrozzeria"
              :disabled="!options.carrozzeria || !Object.keys(options.carrozzeria).length"
              @change="handleSelectChange('carrozzeria')"
              :name="'choice[carrozzeria]'"
              :isOpen="openDropdown === 3"
              @toggle="handleToggle(3)"
            ></custom-select>

            <custom-select
              v-model="params.porte"
              :options="formattedOptions(options.porte)"
              :placeholder="placeholders.porte"
              :disabled="!options.porte || !Object.keys(options.porte).length"
              @change="handleSelectChange('porte')"
              :name="'choice[porte]'"
              :isOpen="openDropdown === 5"
              @toggle="handleToggle(5)"
            ></custom-select>

            <custom-select
              v-model="params.cilindrata"
              :options="formattedOptions(options.cilindrata)"
              :placeholder="placeholders.cilindrata"
              :disabled="!options.cilindrata || !Object.keys(options.cilindrata).length"
              @change="handleSelectChange('cilindrata')"
              :name="'choice[cilindrata]'"
              :isOpen="openDropdown === 7"
              @toggle="handleToggle(7)"
            ></custom-select>
        </div>
        </div>
        <div class="send-find-car">
          <button
            class="find-car"
            type="submit"
            :class="{ disabled: !isFormComplete }"
            :disabled="!isFormComplete || loading"
            title="Trova veicolo"
          >
            <template v-if="!loading">Trova veicolo</template>
            <loader v-else size="20px" />
          </button>
        </div>
      </form>
    </div>
    <div
      id="myCarDropdownContainer"
      class="my-car-dropdown-container"
      :class="{ hidden: !isMyCarDropdownOpen }"
    >
      <div class="close-dropdown">
        <!-- <button type="button" id="closeMyCarDropdown" class="close-dropdown" v-on:click="closeMyCarDropdown">
          <svg xmlns="http://www.w3.org/2000/svg" width="14.004" height="14" viewBox="0 0 14.004 14">
            <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M19.946,18.289l5-5A1.172,1.172,0,0,0,23.29,11.63l-5,5-5-5a1.172,1.172,0,1,0-1.657,1.657l5,5-5,5a1.172,1.172,0,1,0,1.657,1.657l5-5,5,5a1.172,1.172,0,1,0,1.657-1.657Z" transform="translate(-11.285 -11.289)" fill="#606060"/>
          </svg>
        </button> -->
      </div>
      <ul class="my-car-list" v-if="isLogged && myCar && Object.keys(myCar).length">
        <li v-for="(car, key) in myCar" :key="key">
          <form action="/api/mycar-selection" method="POST">
            <input type="hidden" name="codiceInfocarAM" :value="key" />
            <input type="hidden" name="quotation_type" :value="quotation_type" />
            <input type="hidden" name="vehicle_type" :value="vehicle_type" />
            <button type="submit" class="my-car-button">
              <img :src="car.img" :alt="car.nome" />
              <span class="text-bold">{{ car.nome }}</span>
            </button>
          </form>
        </li>
      </ul>
      <p v-else-if="isLogged">Non hai auto salvate.</p>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';
import CustomSelect from './CustomSelect.vue';
import axios from 'axios';
export default {
  name: 'SelectCarDropdown',
  components: {
    Loader,
    CustomSelect,
  },
  props: {
    vehicle_type: {
      type: Number,
      required: true,
    },
    quotation_type: {
      type: String,
      required: true,
    },
    isLogged: {
      type: Boolean,
      required: false,
    },
    myCar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      isMyCarDropdownOpen: false,
      loading: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      selectOrder: ['marca', 'anno_im', 'mese_im', 'modello', 'alimentazione', 'carrozzeria', 'porte', 'cilindrata'],
      options: {
        marca: {},
        alimentazione: {},
        anno_im: {},
        mese_im: {},
        modello: {},
        carrozzeria: {},
        porte: {},
        cilindrata: {},
      },
      params: {
        marca: '',
        alimentazione: '',
        anno_im: '',
        mese_im: '',
        modello: '',
        carrozzeria: '',
        porte: '',
        cilindrata: '',
      },
      placeholders: {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        mese_im: 'Mese prima immatricolazione*',
        modello: 'Modello*',
        alimentazione: 'Alimentazione*',
        carrozzeria: 'Carrozzeria*',
        porte: 'Porte*',
        cilindrata: 'Cilindrata*',
      },
      openDropdown: null,
    };
  },
  computed: {
    isFormComplete() {
      return (
        this.params.marca &&
        this.params.alimentazione &&
        this.params.anno_im &&
        this.params.mese_im &&
        this.params.modello &&
        this.params.carrozzeria &&
        this.params.porte &&
        this.params.cilindrata
      );
    },
    isNominale() {
      return this.quotation_type === 'nominale';
    },
    isLiveMarket() {
      return this.quotation_type === 'live-market';
    },
    isSponsor() {
      return this.quotation_type === 'sponsor';
    },
  },
  methods: {
    toggleDropdown() {
      if (this.isMyCarDropdownOpen) {
        this.isMyCarDropdownOpen = false;
      }
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    toggleMyCarDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false;
      }
      this.isMyCarDropdownOpen = !this.isMyCarDropdownOpen;
    },
    closeMyCarDropdown() {
      this.isMyCarDropdownOpen = false;
    },
    formattedOptions(options) {
      if (!options || !Object.keys(options).length) {
        return [];
      }
      return Object.keys(options).map(key => ({
        value: key,
        text: options[key],
      }));
    },
    getDefaultPlaceholder(field) {
      const defaultPlaceholders = {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        mese_im: 'Mese prima immatricolazione*',
        modello: 'Modello*',
        alimentazione: 'Alimentazione*',
        carrozzeria: 'Carrozzeria*',
        porte: 'Porte*',
        cilindrata: 'Cilindrata*',
      };
      return defaultPlaceholders[field] || '';
    },
    async fetchChoices() {
        const requestData = {
            ...this.params,
            vehicle_type: this.vehicle_type,
        };
        try {
            const response = await axios.post('/api/choices', requestData);
            this.options = response.data;
            await this.autoSelectOptions();
        } catch (error) {
            console.error('Error fetching choices:', error);
        }
    },
    handleSelectChange(changedField) {
        this.resetSubsequentSelects(changedField);
        this.autoSelectOptions();
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.loading = true;
      try {
        this.$refs.findCar.submit();
      } catch (error) {
        window.alert(
          'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
        );
      }
      this.loading = false;
    },
    handleCarSelection(id) {
      try {
        this.$refs.findMyCar.submit();
      } catch (error) {
        window.alert(
          'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
        );
      }
    },
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    resetSubsequentSelects(changedField) {
      const index = this.selectOrder.indexOf(changedField);

      if (index !== -1) {
        // Ottieni i campi successivi
        const subsequentFields = this.selectOrder.slice(index + 1);

        // Resetta i parametri e le opzioni delle select successive
        subsequentFields.forEach(field => {
          this.params[field] = '';
          this.options[field] = {};
          this.placeholders[field] = this.getDefaultPlaceholder(field);
        });
      }
    },
    async autoSelectOptions(paramsChanged = false, loopCounter = 0, maxLoops = 10) {
        if (loopCounter >= maxLoops) {
            console.warn('Raggiunto il numero massimo di iterazioni per la selezione automatica');
            return;
        }
        const requestData = {
            ...this.params,
            vehicle_type: this.vehicle_type,
        };

        try {
            const response = await axios.post('/api/choices', requestData);
            this.options = response.data;
            paramsChanged = false;

            let nextFieldToSelect = null;
            for (const field of this.selectOrder) {
                if (!this.params[field]) {
                    nextFieldToSelect = field;
                    break;
                }
            }

            for (const field in this.options) {
                if (!this.params[field]) {
                    const fieldOptions = this.options[field];
                    const optionsArray = this.formattedOptions(fieldOptions);

                    if (optionsArray.length === 1) {
                        this.params[field] = optionsArray[0].value;
                        paramsChanged = true;
                    } else {
                        // Se questo campo è il prossimo da selezionare
                        if (field === nextFieldToSelect) {
                            if (optionsArray.length === 0) {
                                // Nessuna opzione disponibile, aggiorna il placeholder
                                this.placeholders[field] = 'Non ci sono modelli disponibili';
                            } else {
                                // Ripristina il placeholder originale se ci sono opzioni disponibili
                                this.placeholders[field] = this.getDefaultPlaceholder(field);
                            }
                        }
                    }
                }
            }

            if (paramsChanged) {
                await this.autoSelectOptions(true, loopCounter + 1, maxLoops);
            }
        } catch (error) {
            console.error('Error fetching choices:', error);
        }
    },
},
mounted() {
    this.autoSelectOptions();
},
};
</script>
<style scoped>
select.selected {
  color: black;
}
.m-0 {
  margin: 0;
}
.mr-2 {
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/SelectCarDropdown.vue